var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',[_c(_vm.spinnerName,{tag:"component"})],1):(_vm.journey)?_c('div',[_c('router-view',{attrs:{"journey":_vm.journey}})],1):_c('div',[_vm._v(" "+_vm._s(_vm.$t('error.retrieving_journey'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }